import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core'
import { FilterComponent } from '../../../../../shared/components/base/filter/filter.component'
import { PostFilter } from 'src/app/shared/interfaces/post/post-filter.interface'
import { FormGroup, FormBuilder, ReactiveFormsModule } from '@angular/forms'
import { InputDropdownComponent } from '../../../../../shared/components/form-elements/input-dropdown/input-dropdown.component'
import { SwitchComponent } from '../../../../../shared/components/form-elements/switch/switch.component'
import { NgSelectModule } from '@ng-select/ng-select'
import { NgOptionHighlightDirective } from '@ng-select/ng-option-highlight'
import { PostsStore } from '../../posts.store'
import { StaffSelectOptionComponent } from 'src/app/shared/components/staff/staff-select-option/staff-select-option.component'

@Component({
    selector: 'sf-post-search',
    imports: [
        ReactiveFormsModule,
        FilterComponent,
        InputDropdownComponent,
        SwitchComponent,
        NgSelectModule,
        NgOptionHighlightDirective,
        StaffSelectOptionComponent,
    ],
    templateUrl: './post-search.component.html',
    styleUrls: ['./post-search.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PostSearchComponent {
    private fb = inject(FormBuilder)
    postsStore = inject(PostsStore)

    filterForm: FormGroup = this.fb.group({
        postTypeId: [null],
        isProcessed: [false],
        isVoid: [false],
        staffId: [null],
        sortColumn: ['id DESC'],
        pageSize: [50],
    })

    sortOptions: Record<string, string>[] = [
        { id: 'id ASC', name: 'Oldest First' },
        { id: 'id DESC', name: 'Newest First' },
    ]

    @Input()
    isCollapsed = false

    @Input()
    set existingFilter(filter: PostFilter) {
        this.filterForm?.patchValue(filter)
    }

    @Output() searchClicked: EventEmitter<PostFilter> = new EventEmitter<PostFilter>()

    search(): void {
        this.postsStore.updateFilter(this.filterForm.value as PostFilter)
    }

    reset(): void {
        this.filterForm.reset()
        this.filterForm.controls['sortColumn'].setValue('id DESC')
        this.filterForm.controls['pageSize'].setValue(50)
        this.search()
    }
}
